<template>
    <div>
        <a-table :columns="columns" :data-source="data" :expanded-row-keys.sync="expandedRowKeys"
            :scroll="{ x: clientWidth}" bordered size="middle">
            <template slot="resultText" slot-scope="text">
                <span v-if="text=='true'" style="color:green;">成功</span>
                <span v-else style="color:red;">失败</span>
            </template>
            <template slot="timeText" slot-scope="text">
                <span style="">{{ (new Date(text)).Format("yy-MM-dd hh:mm:ss:S") }}</span>
            </template>
            <!-- 报文 -->
            <template slot="readParams" slot-scope="text,record">
                <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParams(record)" />
            </template>

            <!-- 时间轴 -->
            <template slot="timeline"  slot-scope="record">
                <div class="line_bar">
                    <a-progress :percent="getPercent(record).percent" :showInfo="false" :success-percent="getPercent(record).successPercent" />
                </div>
            </template>
        </a-table>

        <a-modal v-model="modalVisible" title="报文" @ok="handleOk">
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="请求参数">

                    <json-viewer :value="currentRequest" :expand-depth=5 copyable boxed sort></json-viewer>
                </a-tab-pane>
                <a-tab-pane key="2" tab="响应结果">
                    <json-viewer :value="currentResponse" :expand-depth=5 copyable boxed sort></json-viewer>
                </a-tab-pane>

            </a-tabs>
        </a-modal>
    </div>

</template>
<script>
import JsonViewer from "vue-json-viewer"
let columns = [
    {
        title: '服务提供方',
        dataIndex: 'appcode',
        align: "left",
        width:500,
    },
    {
        title: '服务调用方',
        dataIndex: 'invokeappcode',
        align: "center",
        width:200,
    },
    {
        title: "运行环境",
        dataIndex: "routetag",
        width:80,
        align: "center",
        ellipsis: true
    },
    {
        title: '服务/方法',
        dataIndex: 'url',
        align: "left",
        width:700,
    },
    
    {
        title: '耗时（ms）',
        dataIndex: 'handtime',
        align: "center",
        width:100,
    },
    {
        title: 'timeline',
        scopedSlots: { customRender: 'timeline' },
        width:150,
    },
    {
        title: '开始时间',
        dataIndex: 'starttime',
        scopedSlots: { customRender: 'timeText' },
        align: "center",
        width:160,
    },
    {
        title: '结束时间',
        dataIndex: 'endtime',
        scopedSlots: { customRender: 'timeText' },
        align: "center",
        width:160,
    },
    {
        title: "报文",
        width:50,
        scopedSlots: { customRender: 'readParams' },
        align: "center",
    },
    {
        title: '调用结果',
        dataIndex: 'success',
        align: "center",
        width:100,
        scopedSlots: { customRender: 'resultText' },
    },
    {
        title: "异常编码",
        dataIndex: "exceptioncode",
        width:200,
        align: "left",
    },
    {
        title: "异常类型",
        dataIndex: "exceptiontype",
        width:80,
        align: "center",
    },
];


export default {
    data() {
        return {
            data:[],
            columns,
            expandedRowKeys: [],
            //自定义变量
            traceData:[],
            clientWidth:800,
            modalVisible:false,
            currentRequest:"",
            currentResponse:"",
            child_count:0,
            max_child_length:0
        };
    },
    components:{
        JsonViewer
    },
    methods:{
        handleOk(){
            this.modalVisible = false;
        },
        getPercent(item){
            let fulltime = this.data[0].handtime;
            let fstime = new Date(this.data[0].starttime).getTime();
            let startTime = new Date(item.starttime).getTime();
            let endTime = new Date(item.endtime).getTime();

            let startP = (((startTime - fstime) / fulltime) * 100 ).toFixed(0);
            let endP = (((endTime - fstime) / fulltime) * 100 ).toFixed(0)
            return {
                percent:parseInt(endP),
                successPercent:parseInt(startP)  
            }
        },
        handleParams(item){
            this.modalVisible = true;
            try {
                this.currentRequest = JSON.parse(item.requestparams);
            } catch (error) {
                this.currentRequest = item.requestparams;
            }
            
            try {
                this.currentResponse = JSON.parse(item.responseresult);
            } catch (error) {
                this.currentResponse = item.responseresult;
            }
        },
        handleTimeData(traceData){
            this.traceData = traceData;
            //找到开始节点
            let firstTarget = traceData[0];
            if(!firstTarget.tracereqparentno){
                let tempF = traceData.filter(item => { return item.tracereqparentno == '' });
                if(tempF.length > 0){
                    firstTarget = tempF[0]
                }
            }
            //递归子节点
            firstTarget.key = firstTarget.tracereqno;//键值
            this.expandedRowKeys.push(firstTarget.key)
            firstTarget.children = this.handleChild(firstTarget);
            this.data = [firstTarget];
            this.columns[0].width = this.child_count * 25 + this.max_child_length * 8
            console.log(this.child_count);
            console.log(this.max_child_length);

        },
        handleChild(traceItem){
            let tempChildren = this.traceData.filter(item => { return item.tracereqparentno == traceItem.tracereqno });
            if(!traceItem.level){
                traceItem.level = 1
            }
            if(traceItem.level > this.child_count){
                this.child_count = traceItem.level
                this.max_child_length = traceItem.appcode.length
            }
            // tempChildren.sort(function (a, b) {
            //     return new Date(a.starttime).getTime() > new Date(b.starttime).getTime() ? 1 : -1
            // });
            tempChildren.forEach(element => {
                element.key = element.tracereqno;
                this.expandedRowKeys.push(element.key)
                element.level = traceItem.level + 1;
                element.children = this.handleChild(element)
            });
            
            return tempChildren;
        }
    }
};
</script>

<style scoped>
    .line_bar{
        width: 100%;
        background: #ebebeb;
        padding: 2px 0;
    }
</style>

<style>
.ant-progress-success-bg{
    background-color: white;
    border-radius: 0 !important;
   
}

.ant-progress-bg{
  border-radius: 0 !important;
}

.ant-progress-inner{
   border-radius: 0 !important;
}
</style>
